<template>
  <div id="sidebarPrincipal" class="hidden">
    <vs-sidebar textWhite v-model="active" :open.sync="activeSidebar">
      <template #header>
        <vs-row justify="space-between">
          <vs-col w="2">
            <template #icon>
              <img src="@/assets/img/hacienda_chiapas.png" alt="logo siahe" />
            </template>
          </vs-col>
          <vs-col w="2">
            <vs-button
              @click="activeSidebar = !activeSidebar"
              shadow
              size="large"
              class="bg-primary-sh text-surface"
            >
              <font-awesome-icon icon="fa-solid fa-arrow-left" />
            </vs-button>
          </vs-col>
        </vs-row>
      </template>

      <!-- <vs-sidebar-item id="home">    
          <router-link class="nav-link" :to="{ name: 'Inicio'}">
            <template #icon>
              <i class='bx bx-grid-alt'></i>
            </template>
            Inicio
          </router-link>
        </vs-sidebar-item> -->

      <vs-sidebar-item :to="{ name: 'Inicio' }" id="Inicio">
        <template #icon>
          <font-awesome-icon icon="fa-solid fa-house" />
        </template>
        <span class="hide-in-minisidebar">Inicio</span>
      </vs-sidebar-item>

      <vs-sidebar-group>
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <font-awesome-icon icon="fa-solid fa-table" />
            </template>
            Tablas
          </vs-sidebar-item>
        </template>

        <vs-sidebar-item id="vuesax" :to="{ name: 'tableVuesax' }">
          Vuesax
        </vs-sidebar-item>
      </vs-sidebar-group>

      
      <vs-sidebar-item id="Sesion">
        <template #icon>
          <i class="bx bxs-music"></i>
        </template>
        <a class="dropdown-item py-3" href="" @click="handleCerrarSesion()"
          >{{ usuario
          }}<font-awesome-icon icon="fa-solid fa-arrow-right-from-bracket" />
          Cerrar sesión</a
        >
      </vs-sidebar-item>
    </vs-sidebar>
  </div>
</template>
<script>
import mapHelper from "@/store/modules/common/map-helper";
export default {
  name: "TheAsideLeft",
  props: {
    activeSidebarMenu: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      active: "home",
      activeSidebar: false,
    };
  },
  computed: {
    usuario() {
      return this.$store.getters["core/auth/getUser"];
    },
  },
  methods: {
    async handleCerrarSesion() {
      await this.$store.dispatch(
        mapHelper.mapmod.SIAHE_AUTH + mapHelper.mapfn.logOut
      );
      this.$router.push({ name: "Login" });
    },
  },
  watch: {
    activeSidebarMenu(value) {
      this.activeSidebar = value;
    },
    activeSidebar(value) {
      if (this.activeSidebarMenu != value) {
        this.$emit("change-active-menu");
      }
    },
  },
};
</script>